import "@fontsource/public-sans";
import { Button, Stack, Typography } from "@mui/joy";
import copy from "copy-to-clipboard";
import { Fragment, useEffect, useState } from "react";
import "./App.css";
import LoginPage from "./LoginPage";
import MainPage from "./MainPage";
import { serverHost } from "./const";

function App() {
  const [loginStatus, setLoginStatus] = useState<{
    pass: boolean;
    isAdmin: boolean;
  }>({ pass: false, isAdmin: false });
  const [isDeviceLegal, setIsDeviceLegal] = useState<boolean>(false);
  const [deviceId, setDeviceId] = useState<string>("");

  const Verify = async () => {
    const uniqueId = btoa(navigator.userAgent);
    const url = `http://${serverHost}/verify?id=${uniqueId}`;

    try {
      const resp: Response = await fetch(url, {
        method: "POST",
      });
      if (!resp.ok) {
        setIsDeviceLegal(false);
      } else {
        setIsDeviceLegal(true);
      }
    } catch (error) {
      console.log(error);
      setIsDeviceLegal(false);
    } finally {
      setDeviceId(uniqueId);
    }
  };

  useEffect(() => {
    Verify();
  }, []);

  const OnLogin = (status: any) => {
    setLoginStatus(status);
  };

  if (loginStatus.pass) {
    if (isDeviceLegal || loginStatus.isAdmin) { 
      return <MainPage isAdmin={loginStatus.isAdmin}></MainPage>;
    } else {
      return (
        <Fragment>
          <Stack spacing={3}>
            <Typography>设备id未注册, 请联系管理人员, 设备id: {deviceId}</Typography>;
            <Button
              onClick={() => {
                copy(deviceId);
                alert("复制成功");
              }}>
              复制设备码到剪切板
            </Button>
          </Stack>
        </Fragment>
      );

    }
  } else {
    return <LoginPage onLogin={OnLogin}></LoginPage>;
  }
}

export default App;
